import { AppleIcon, Button } from '@iheartjane/reefer';

export interface AppleButtonProps {
  /** Disables the button (e.g., while the Apple SDK is loading). */
  disabled?: boolean;

  /** Label and ariaLabel for the button. Defaults to "Sign in with Apple". */
  label?: string;

  /** Function called when the button is clicked. */
  onClick(): void;
}

export const AppleButton = ({
  disabled,
  label = 'Sign in with Apple',
  onClick,
}: AppleButtonProps) => (
  <Button
    ariaLabel={label}
    data-testid="apple-sign-in-button"
    disabled={disabled}
    full
    label={label}
    onClick={onClick}
    startIcon={<AppleIcon size="sm" />}
    variant="tertiary"
  />
);
